import { apiFetch } from './client';
import type { AssignableUser } from '$lib/types';

// GET /api/projects/:id/members — the sole user-listing endpoint members
// can reach (only users granted to that project; id+name only).
export const membersApi = {
  forProject: (projectId: number) => apiFetch<{ results: AssignableUser[] }>(`/projects/${projectId}/members`)
};
